export const setPARKINGREQUEST = "setPARKINGREQUEST";
export const setPARKINGRATE = "setPARKINGRATE";
export const setTICKETINGREQUEST = "setTICKETINGREQUEST";
export const setPSPREQUEST = "setPSPREQUEST";
export const setEPIREQUEST = "setEPIREQUEST";
export const setFISCALDEVICEREQUEST = "setFISCALDEVICEREQUEST";
export const setUPLOADREQUESTTYPE = "setUPLOADREQUESTTYPE";
export const setDEFAULTREQUESTTYPE = "setDEFAULTREQUESTTYPE";
